import Stack from '@mui/material/Stack';
import React from 'react';
import ToRouteModeMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/route/toRouteMode/ToRouteModeMutateSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import SaveVoyageSecondaryBtn from "@containers/singleVoyage/mutateVoyage/saveVoyage/SaveVoyageSecondaryBtn";
import MutateTasksMutateSingleVoyageModal
    from "@containers/singleVoyage/mutateVoyage/tasks/MutateTasksMutateSingleVoyageModal";

const TopActionBarMutateSingleVoyage = () => {

    const {modeSecondarySidebar} = useViewContextMutateSingleVoyage()

    return (
        <Stack
            direction={'row'}
            gap={'9px'}
        >

            <MutateTasksMutateSingleVoyageModal/>

            {modeSecondarySidebar !== 'route' && <ToRouteModeMutateSingleVoyage/>}

            <SaveVoyageSecondaryBtn/>

        </Stack>
    );
};

export default TopActionBarMutateSingleVoyage;
